import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IListLayoutAccessibility } from 'src/app/models/interfaces/list-layout-accessibility.interface';
import { IListLayout } from 'src/app/models/interfaces/list-layout.interface';
import { ListLayoutWorkflowsAccessibilityFormComponent } from '../list-layout-workflows-accessibility-form/list-layout-workflows-accessibility-form.component';
import { ListLayoutWorkflowsColumnsFormComponent } from '../list-layout-workflows-columns-form/list-layout-workflows-columns-form.component';
import { ListLayoutWorkflowsDetailContext } from '../list-layout-workflows-detail-context';
import { ListLayoutWorkflowsFormComponent } from '../list-layout-workflows-form/list-layout-workflows-form.component';

@Component({
    selector: 'app-list-layout-workflows-detail',
    templateUrl: './list-layout-workflows-detail.component.html',
    styleUrls: ['./list-layout-workflows-detail.component.scss'],
    imports: [MatTabsModule, ListLayoutWorkflowsFormComponent, ListLayoutWorkflowsColumnsFormComponent, ListLayoutWorkflowsAccessibilityFormComponent],
})
export class ListLayoutWorkflowsDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public listLayoutUpdated: EventEmitter<IListLayout> = new EventEmitter();

    /**
     * Emis lorsque le formulaire d'accessibilité est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public accessibilitiesUpdated: EventEmitter<IListLayoutAccessibility[]> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Contexte du formulaire.
     */
    public _context: ListLayoutWorkflowsDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ListLayoutWorkflowsDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ListLayoutWorkflowsDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param listLayout: Infos du listLayout modifié.
     */
    public onListLayoutUpdated(listLayout: IListLayout) {
        this.listLayoutUpdated.emit(listLayout);
    }

    /** Appellé lorsque des changements sur le formulaire "Accessibilité" sont sauvegardés.*/
    public onAccessibilitiesUpdated(accessibilities: IListLayoutAccessibility[]) {
        this.accessibilitiesUpdated.emit(accessibilities);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param user: Infos de l'article modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
